export default __webpack_public_path__ + "static/media/causes-3.24c0dd73.png";